/* eslint-disable no-alert */
import React from 'react'
import firebase from 'firebase/app'
import get from 'lodash/get'
import upperCase from 'lodash/upperCase'

import { Button, Popup, Checkbox } from 'semantic-ui-react'
import styled from 'styled-components'

const Divider = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

export default class Setting extends React.Component {
  state = {
    phnHighDemand: false,
    repHighDemand: false,
    autoConfirm: false,

    highDemandLoading: true,
    autoConfirmLoading: true,
  }

  componentDidMount() {
    this.subscriber = firebase.database().ref('configs')

    this.subscriber.on('value', snapshot => {
      const configs = snapshot.val()

      const phnHighDemand = get(configs, 'pnh.order_traffic_configs.high_demand.enable', false)
      const repHighDemand = get(configs, 'rep.order_traffic_configs.high_demand.enable', false)
      const autoConfirm = get(configs, 'auto_confirm', false)

      this.setState({
        phnHighDemand,
        repHighDemand,
        autoConfirm,

        highDemandLoading: false,
        autoConfirmLoading: false,
      })
    })
  }

  componentWillUnmount() {
    if (this.subscriber) {
      this.subscriber.off()
    }
  }

  onHighDemandChange = async region => {
    this.setState({ highDemandLoading: true })

    const { phnHighDemand, repHighDemand } = this.state

    const { key, value } = {
      pnh: {
        key: 'phnHighDemand',
        value: phnHighDemand
      },
      rep: {
        key: 'repHighDemand',
        value: repHighDemand
      },
    }[region]

    const newValue = !value

    const message = `Are you sure to ${newValue ? 'show' : 'hide'} high demand for customer in ${upperCase(region)}?`
    const confirmation = window.confirm(message)

    if (confirmation) {
      const updates = {}

      updates[`/configs/${region}/order_traffic_configs/high_demand/enable`] = newValue
      updates[`/configs/${region}/order_traffic_configs/high_demand/visibility`] = newValue

      if (region === 'pnh') {
        updates['/configs/show_high_demand'] = newValue // For old mobile app version
      }

      await firebase.database().ref().update(updates)
    }

    this.setState({
      highDemandLoading: false,
      [key]: confirmation ? newValue : value
    })
  }

  onAutoConfirmChange = async () => {
    this.setState({ autoConfirmLoading: true })

    const { autoConfirm } = this.state
    const newValue = !autoConfirm

    const message = `Are you sure to ${newValue ? 'activate' : 'deactivate'} auto confirm?`
    const confirmation = window.confirm(message)

    if (confirmation) {
      await firebase.database().ref().update({
        '/configs/auto_confirm': newValue
      })
    }

    this.setState({
      autoConfirmLoading: false,
      autoConfirm: confirmation ? newValue : autoConfirm
    })
  }

  render() {
    const { phnHighDemand, repHighDemand, autoConfirm, autoConfirmLoading, highDemandLoading } = this.state

    return (
      <Popup
        trigger={<Button floated="right">Traffic Setting</Button>}
        position="left center"
        on={['click']}
      >
        <Checkbox
          toggle
          checked={phnHighDemand}
          label="High Demand (PNH)"
          disabled={highDemandLoading}
          onChange={() => this.onHighDemandChange('pnh')}
        />

        <Divider />

        <Checkbox
          toggle
          checked={repHighDemand}
          label="High Demand (REP)"
          disabled={highDemandLoading}
          onChange={() => this.onHighDemandChange('rep')}
        />

        <Divider />

        <Checkbox
          toggle
          checked={autoConfirm}
          label="Auto Confirm"
          onChange={this.onAutoConfirmChange}
          disabled={autoConfirmLoading}
        />
      </Popup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/TrafficConfig.js